import { Component, Inject, OnInit } from '@angular/core';
import { HubConnectionState } from '@microsoft/signalr';

import { SignalRHubsConnection } from './SignalRHubsConnection';
import { SignalRHubsConnectionToken } from './SignalRHubsConnectionToken';

@Component({
	selector: 'signalr-connection-status',
	templateUrl: './SignalRConnectionStatus.Component.html'
})
export class SignalrConnectionStatusComponent implements OnInit {
	public isHealthy: boolean = true;

	constructor(
		@Inject(SignalRHubsConnectionToken) public signalrHubsConnection: SignalRHubsConnection
	) {}

	public ngOnInit(): void {
		this.update();
		this.signalrHubsConnection.stateChanged$.subscribe(() => this.update());
	}

	public update(): void {
		this.isHealthy = !this.signalrHubsConnection.started
			|| this.signalrHubsConnection.getConnectionStatus() === HubConnectionState.Connected;
	}
}
